import { getViewData } from '../modules/view-data';

export default {
    /**
     * Provide the partner data and a config
     * helper to retrieve Partner data
     *
     * @param {Object} Vue
     */
    install(Vue) {
        const $partner = Object.assign({}, getViewData('microsite'));
        $partner.config = (key, fallback) => getViewData(`microsite.config.${key}`, fallback);

        Vue.prototype.$partner = $partner;
        Vue.prototype.$isPartner = Boolean($partner.id);
        Vue.prototype.$platformName = $partner.name || 'YourParkingSpace';
    },
};
